module.exports = __webpack_public_path__ + "static/media/loader.1b06ae53.gif";